export const LANGUAGES = {
  en: 'English',
  es: 'Español',
  pt: 'Português',
} as const satisfies Record<UserLocale, string>;
